import { download } from '@/services/file.service.js'
import { useAuthStore } from '@/store/auth.js'

export const Public = axios => ({
  interview: {
    get (slug) {
      const auth = useAuthStore()
      return axios.get(`/v1/public/candidate/${slug}/interviews`, {
        headers: { 'X-locale': auth.getLocale }
      })
    },
    save (slug, payload) {
      return axios.post(`/v1/public/candidate/${slug}/interviews`, payload)
    },
    updateStep (slug, step) {
      return axios.put(`/v1/public/candidate/${slug}/interviews`, {
        interview_step: step
      })
    },
    finish (slug) {
      return axios.put(`/v1/public/candidate/${slug}/interviews/finish`)
    },
    congrats (slug) {
      return axios.get(`/v1/public/candidate/${slug}/interviews/congrats`)
    }
  },
  confirmStorage (profile) {
    return axios.put(`/v1/public/profiles/${profile}/confirm-storage`)
  },
  longList (slug) {
    return axios.get(`/v1/public/profile-lists/${slug}/long`)
  },
  shortList (slug) {
    return axios.get(`/v1/public/profile-lists/${slug}/short`)
  },
  acceptCandidate (slug, profile) {
    return axios.put(`/v1/public/profile-lists/${slug}/${profile}/accept`)
  },
  rejectCandidate (slug, profile) {
    return axios.put(`/v1/public/profile-lists/${slug}/${profile}/reject`)
  },
  async downloadList (slug, type, name) {
    const { data } = await axios({
      url: `/v1/public/profile-lists/${slug}/${type}/pdf`,
      method: 'GET',
      responseType: 'blob'
    })

    return download(data, name)
  }
})
